<script>
	import { mapActions, mapGetters } from 'vuex'

	export default 
	{
    name: 'logout',
    computed:{
      ...mapGetters('session', ['isLoggedIn', 'getJwt', 'getWhiteLabel'])
    },
      methods: 
      {
        ...mapActions('session', ['logout']),
    },
    created()
        {
          window.analytics.track("Logout");
          this.logout();
          console.log('R  -  :', this.getJwt, this.isLoggedIn)
          console.log('J  -  :', localStorage.getItem('jwt'))
          setTimeout(() => {
            window.location.href = '/signin'
          }, 2000)

		    }
	}
</script>


<template>
    <div style="height:100%;"  class="ui grid container middle aligned">
      <div class="ten wide computer ten wide mobile centered column center aligned">
        <div style="font-size: 24px;" class="ui basic segment">
          <p>Bye 👋🥺</p>
          <img v-show="!getWhiteLabel" style="width: 100%; border-radius: 10px;" src="https://miro.medium.com/max/3840/1*tG5a07sbgVn05l077FdK_Q.png" alt="">
        </div>
      </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/auth/Logout.vue